import { IconTypes } from "../Icons";

export default function TopupIcon({
  color = "#ffffff",
  fontSize = "1.6rem",
  rotate = 0,
  className = "",
}: IconTypes) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="200"
      height="200"
      viewBox="0 0 200 200"
      fill="none"
      style={{
        width: "1em",
        height: "1em",
        fontSize,
        transform: `rotate(${rotate}deg)`,
      }}
      className={className}
    >
      <path
        d="M178.017 200H13.6496C10.8066 200 8.50195 197.695 8.50195 194.852V127.548C8.50195 119.938 14.6715 113.768 22.282 113.768H169.385C176.996 113.768 183.165 119.938 183.165 127.548V194.852C183.165 197.695 180.86 200 178.017 200Z"
        fill="#D8ECFE"
      />
      <path
        d="M169.385 113.768H153.232C160.843 113.768 167.013 119.938 167.013 127.548V194.723C167.013 196.837 165.965 198.813 164.215 200H178.018C180.861 200 183.166 197.695 183.166 194.852V127.548C183.165 119.938 176.996 113.768 169.385 113.768Z"
        fill="#C4E2FF"
      />
      <path
        d="M95.834 146.695C120.08 146.695 139.734 127.04 139.734 102.795C139.734 78.549 120.08 58.8941 95.834 58.8941C71.5885 58.8941 51.9336 78.549 51.9336 102.795C51.9336 127.04 71.5885 146.695 95.834 146.695Z"
        fill="#FFD15B"
      />
      <path
        d="M95.8344 58.8941C93.0387 58.8941 90.3047 59.1586 87.6543 59.6582C107.99 63.4914 123.375 81.3449 123.375 102.795C123.375 124.244 107.99 142.098 87.6543 145.931C90.3051 146.43 93.0387 146.695 95.8344 146.695C120.08 146.695 139.735 127.04 139.735 102.795C139.735 78.5492 120.08 58.8941 95.8344 58.8941Z"
        fill="#FFC344"
      />
      <path
        d="M107.045 68.6367C103.515 67.4711 99.7449 66.8434 95.832 66.8434C76.0109 66.8434 59.8828 82.9715 59.8828 102.793C59.8828 122.618 76.0109 138.746 95.832 138.746C99.7449 138.746 103.515 138.118 107.045 136.953C121.396 132.233 131.147 102.793 131.147 102.793C131.147 102.793 121.396 73.3566 107.045 68.6367ZM119.387 121.085C113.925 128.108 105.398 132.632 95.832 132.632C79.3816 132.632 65.9965 119.247 65.9965 102.793C65.9965 86.3422 79.3816 72.957 95.832 72.957C105.398 72.957 113.925 77.4812 119.387 84.5C123.324 89.5582 128.087 95.9043 128.087 102.793C128.087 109.681 123.324 116.031 119.387 121.085Z"
        fill="#FFE177"
      />
      <path
        d="M123.612 113.686C124.941 110.31 125.672 106.635 125.672 102.793C125.672 95.9043 123.324 89.5582 119.387 84.5C116.546 78.3004 112.295 72.8754 107.045 68.6367C121.396 73.3566 131.786 86.8844 131.786 102.793C131.786 118.705 121.396 132.233 107.045 136.953C112.295 132.714 116.546 127.289 119.387 121.085C121.128 118.85 122.558 116.362 123.612 113.686Z"
        fill="#FFD15B"
      />
      <path
        d="M83.6707 118.025C84.4961 118.025 85.3215 117.71 85.9516 117.08L110.332 92.6992C111.592 91.4398 111.592 89.3973 110.332 88.1379C109.073 86.8785 107.03 86.8785 105.771 88.1379L81.3898 112.519C80.1305 113.778 80.1305 115.821 81.3898 117.08C82.0199 117.71 82.8457 118.025 83.6707 118.025Z"
        fill="#F3F0F3"
      />
      <path
        d="M141.116 148.897H50.5531C48.8863 148.897 47.5352 147.546 47.5352 145.879C47.5352 144.212 48.8863 142.861 50.5531 142.861H141.116C142.783 142.861 144.134 144.212 144.134 145.879C144.134 147.546 142.782 148.897 141.116 148.897Z"
        fill="#C4E2FF"
      />
      <path
        d="M18.6957 26.4246C17.0289 26.4246 15.6777 25.0734 15.6777 23.4066V20.7004C15.6777 19.0332 17.0289 17.6824 18.6957 17.6824C20.3625 17.6824 21.7137 19.0336 21.7137 20.7004V23.4066C21.7141 25.0734 20.3625 26.4246 18.6957 26.4246Z"
        fill="#26A6FE"
      />
      <path
        d="M18.6957 8.74219C17.0289 8.74219 15.6777 7.39102 15.6777 5.72422V3.01797C15.6777 1.35117 17.0289 0 18.6957 0C20.3625 0 21.7137 1.35117 21.7137 3.01797V5.72422C21.7141 7.39141 20.3625 8.74219 18.6957 8.74219Z"
        fill="#26A6FE"
      />
      <path
        d="M11.2086 16.2305H8.50234C6.83555 16.2305 5.48438 14.8793 5.48438 13.2125C5.48438 11.5457 6.83555 10.1945 8.50234 10.1945H11.2086C12.8754 10.1945 14.2266 11.5457 14.2266 13.2125C14.2266 14.8793 12.8754 16.2305 11.2086 16.2305Z"
        fill="#60B7FF"
      />
      <path
        d="M28.8902 16.2305H26.184C24.5172 16.2305 23.166 14.8793 23.166 13.2125C23.166 11.5457 24.5172 10.1945 26.184 10.1945H28.8902C30.557 10.1945 31.9082 11.5457 31.9082 13.2125C31.9082 14.8793 30.557 16.2305 28.8902 16.2305Z"
        fill="#60B7FF"
      />
      <path
        d="M39.2645 69.2211C50.412 69.2211 59.4488 60.1842 59.4488 49.0367C59.4488 37.8892 50.412 28.8523 39.2645 28.8523C28.1169 28.8523 19.0801 37.8892 19.0801 49.0367C19.0801 60.1842 28.1169 69.2211 39.2645 69.2211Z"
        fill="#FFE177"
      />
      <path
        d="M39.2641 28.8523C37.1332 28.8523 35.0805 29.1848 33.1523 29.7969C41.3117 32.3867 47.225 40.0199 47.225 49.0367C47.225 58.0535 41.3117 65.6867 33.1523 68.2766C35.0805 68.8887 37.1332 69.2211 39.2641 69.2211C50.4113 69.2211 59.4484 60.1844 59.4484 49.0367C59.4484 37.8891 50.4117 28.8523 39.2641 28.8523Z"
        fill="#FFD15B"
      />
      <path
        d="M43.5625 37.4441C42.2223 36.9453 40.7738 36.6715 39.2645 36.6715C32.4477 36.6715 26.8984 42.2207 26.8984 49.0379C26.8984 55.8551 32.4477 61.4 39.2645 61.4C40.7734 61.4 42.2223 61.1262 43.5625 60.6273C48.2668 58.8808 51.627 54.3457 51.627 49.0379C51.627 43.7301 48.2668 39.1945 43.5625 37.4441ZM39.2648 55.3637C35.7758 55.3637 32.9348 52.5266 32.9348 49.0379C32.9348 45.5488 35.7758 42.7078 39.2648 42.7078C42.7539 42.7078 45.591 45.5488 45.591 49.0379C45.5906 52.5266 42.7539 55.3637 39.2648 55.3637Z"
        fill="#FFD15B"
      />
      <path
        d="M51.627 49.0375C51.627 54.3453 48.2668 58.8805 43.5625 60.627C45.8723 57.3473 47.2242 53.3512 47.2242 49.0375C47.2242 44.7195 45.8723 40.7234 43.5625 37.4438C48.2668 39.1945 51.627 43.7297 51.627 49.0375Z"
        fill="#FFC344"
      />
      <path
        d="M120.348 0H187.588C191.414 0 194.516 3.10195 194.516 6.92852V74.168C194.516 77.9945 191.414 81.0965 187.588 81.0965H120.348C116.522 81.0965 113.42 77.9945 113.42 74.168V6.92852C113.42 3.10195 116.522 0 120.348 0Z"
        fill="#60B7FF"
      />
      <path
        d="M187.588 0H175.512C179.338 0 182.44 3.10195 182.44 6.92852V74.168C182.44 77.9945 179.338 81.0965 175.512 81.0965H187.588C191.414 81.0965 194.516 77.9945 194.516 74.168V6.92852C194.516 3.10195 191.414 0 187.588 0Z"
        fill="#26A6FE"
      />
      <path
        d="M158.316 17.7316L172.137 31.5555C174.464 33.8836 174.678 37.6754 172.462 40.1098C170.096 42.709 166.069 42.7801 163.612 40.323L161.676 38.3871C161.097 37.8078 160.106 38.218 160.106 39.0371V60.4328C160.106 63.725 157.576 66.5574 154.288 66.7125C150.777 66.8777 147.878 64.0801 147.878 60.6055V39.032C147.878 38.2129 146.888 37.8027 146.309 38.3816L144.369 40.3211C138.687 45.9496 130.096 37.35 135.724 31.6738L149.669 17.7309C152.058 15.3434 155.929 15.3437 158.316 17.7316Z"
        fill="#F3F0F3"
      />
    </svg>
  );
}
